/**
 * Shared timeline and timeslot multipliers.
 * Price is always for the product's minimum unit; multiplier = selected / min.
 */

export function getDaysPerTimelineUnit(timeline) {
  if (timeline === 'Day' || timeline === 'One Time') return 1;
  if (timeline === 'Week') return 7;
  if (timeline === 'Month') return 30;
  if (timeline === 'Year') return 365;
  return 1;
}

export function timelineMultiplier(selectedTimelineQuantity, minOrderQuantitytimeline) {
  const min = Number(minOrderQuantitytimeline) > 0 ? Number(minOrderQuantitytimeline) : 1;
  const selected = Number(selectedTimelineQuantity) || 0;
  if (selected <= 0) return 0;
  return selected / min;
}

export function timeslotMultiplier(selectedSeconds, minTimeslotSeconds) {
  const min = Number(minTimeslotSeconds) > 0 ? Number(minTimeslotSeconds) : 1;
  const selected = Number(selectedSeconds) || 0;
  if (selected <= 0) return 0;
  return selected / min;
}

export function timelineDaysMultiplier(selectedDurationDays, variant) {
  const minQty = Number(variant?.minOrderQuantitytimeline) > 0 ? Number(variant.minOrderQuantitytimeline) : 1;
  const timeline = variant?.Timeline || 'Day';
  const daysPerUnit = getDaysPerTimelineUnit(timeline);
  const minTimelineDays = minQty * daysPerUnit;
  const selected = Number(selectedDurationDays) || 0;
  if (selected <= 0) return 0;
  return selected / minTimelineDays;
}

export function getMinTimelineDays(variant) {
  const minQty = Number(variant?.minOrderQuantitytimeline) > 0 ? Number(variant.minOrderQuantitytimeline) : 1;
  const timeline = variant?.Timeline || 'Day';
  return minQty * getDaysPerTimelineUnit(timeline);
}

/**
 * Flat /10 factor for media timeslot (BoughtSeconds).
 * 10 seconds is the global pricing unit for media timeslots — independent of
 * the seller's minTimeslotSeconds (which is min order quantity, not the price unit).
 */
export function slotTenFactor(seconds) {
  const s = Number(seconds) || 0;
  return s / 10;
}

/**
 * Conditional /10 factor for Airport timeline.
 * If timeline >= 10, divide by 10; otherwise use the value as-is.
 */
export function airportTimelineFactor(value) {
  const v = Number(value) || 0;
  if (v <= 0) return 0;
  return v >= 10 ? v / 10 : v;
}

/**
 * Hoarding is priced in fixed 10-day blocks (see tenBlockFactor): the seller's
 * DiscountedPrice is a per-10-day-block rate, so durations are only ever sold in
 * multiples of 10 days (10, 20, 30 …) — independent of the variant's
 * minOrderQuantitytimeline, which does not drive hoarding pricing.
 */
export const HOARDING_BLOCK_DAYS = 10;

/**
 * 10-unit block factor used by Hoarding (days) and Multiplex/DOOH (seconds):
 * value === 10 → ×1, value > 10 → value / 10 (so 20 → ×2, 30 → ×3).
 */
export function tenBlockFactor(value) {
  const v = Number(value) || 0;
  return v > 10 ? v / 10 : 1;
}

export function getMultiplesOfMin(min, max) {
  const m = Number(min) > 0 ? Number(min) : 1;
  const mx = Number(max) > 0 ? Number(max) : m;
  if (mx < m) return [m];
  const count = Math.floor(mx / m);
  return Array.from({ length: count }, (_, i) => (i + 1) * m);
}
